import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=730905de&"
import script from "./Partner.vue?vue&type=script&lang=ts&"
export * from "./Partner.vue?vue&type=script&lang=ts&"
import style0 from "./Partner.vue?vue&type=style&index=0&id=730905de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QBtn,QTooltip,QIntersection,QIcon,QStepper,QStep,QStepperNavigation});
